/**
 * 导航功能号枚举
 * @description 用于页面跳转和功能导航的标识码
 */
export const NavCode = {
  // ==================== 基础功能 ====================
  /**
   * 跳转到委托方引导页
   * @permission 无需权限
   * @payload 无
   */
  NAV_TUTORIAL: 1,

  /**
   * 聊天界面
   * @permission 需登录
   * @payload {object} 聊天参数
   */
  NAV_MESSAGE: 5,

  /**
   * 稿件详情页
   * @permission 需登录
   * @payload {number} artworkId - 稿件ID
   */
  ARTWORK_DETAIL: 6,

  /**
   * 内部H5页面
   * @permission 根据页面而定
   * @payload {string} url - 页面地址
   */
  INNER_WEB_VIEW: 7,

  /**
   * 外部H5页面
   * @permission 无需权限
   * @payload {string} url - 页面地址
   */
  OUTER_WEB_VIEW: 8,

  /**
   * 关闭WebView
   * @permission 无需权限
   * @payload 无
   */
  CLOSE_WEBVIEW: 9,

  /**
   * 打开系统浏览器（外部）
   * @permission 无需权限
   * @payload {string} url - 页面地址
   */
  OPEN_PHONE_BROWSER: 10,

  /**
   * 向 RN 索取当前登录 token（H5→RN 有返回值）
   * @permission 无需权限
   * @payload 无
   * @returns JSON 字符串 `{ token: string }`；未登录时为 null，不带 expire
   */
  GET_AUTH_TOKEN: 11,

  /**
   * 统一收银台（容量包等）
   * @permission 需登录
   * @payload {string} order_id - 订单号
   * @payload {string} notes - 订单说明
   * @payload {number} price - 应付金额（分）
   */
  NAV_PAYMENT_COUNTER: 120,

  /**
   * 实名找回跳转 Native F2A 页面
   * @permission 无需登录（找回场景）
   * @payload { ticket: string, expire: number }
   */
  NAV_F2A_REALID: 101,

  /**
   * 人脸核身验证
   * @permission 无需登录（找回场景）
   * @payload FaceId 核身参数
   */
  NAV_FACEID_VERIFY: 102,

  // ==================== 订单相关 ====================
  /**
   * 订单详情页 (旧版)
   * @permission 需登录
   * @payload {number} orderId - 订单ID
   */
  NAV_ORDER_DETAIL_DATA_OLD: 1001,

  /**
   * 订单动态页 (旧版)
   * @permission 需登录
   * @payload {number} orderId - 订单ID
   */
  NAV_ORDER_DETAIL_EVENT_OLD: 1002,

  /**
   * 订单稿件页 (旧版)
   * @permission 需登录
   * @payload {number} orderId - 订单ID
   */
  NAV_ORDER_DETAIL_DRAFT_OLD: 1003,

  /**
   * 子订单记录页 (旧版)
   * @permission 需登录
   * @payload {number} orderId - 订单ID
   */
  NAV_ORDER_DETAIL_PAY_ORDER_OLD: 1004,

  /**
   * 订单详情页 (新版)
   * @permission 需登录
   * @payload {number} orderId - 订单ID
   */
  NAV_ORDER_DETAIL_DATA: 1005,

  /**
   * 订单动态页 (新版)
   * @permission 需登录
   * @payload {number} orderId - 订单ID
   */
  NAV_ORDER_DETAIL_EVENT: 1006,

  /**
   * 订单稿件页 (新版)
   * @permission 需登录
   * @payload {number} orderId - 订单ID
   */
  NAV_ORDER_DETAIL_DRAFT: 1007,

  /**
   * 子订单记录页 (新版)
   * @permission 需登录
   * @payload {number} orderId - 订单ID
   */
  NAV_ORDER_DETAIL_PAY_ORDER: 1008,

  /**
   * 集市订单详情页
   * @permission 需登录
   * @payload {number} orderId - 订单ID
   */
  NAV_ORDER_DETAIL_MARKET: 2001,

  /**
   * 得闲兽聚联动活动页
   * @permission 无需权限
   * @payload 无
   */
  EVENT_YUMCHA_2025: 10001,

  /**
   * 连通性测试(用于测试 H5->RN 获取返回值)
   * @permission 无需权限
   * @payload 无
   */
  EVENT_BRIDGE_TEST: 114514,
};
